import { Pagination, PaginationProps, Table, TableBodyProps, TableCellProps, TableFooterProps, TableHeaderCellProps, TableHeaderProps, TableProps } from "semantic-ui-react";

type BPTableProps = TableProps & {};

export function BPTable(props: BPTableProps) {
    return <Table {...props}>{props.children}</Table>;
}

type BPTableRowProps = TableProps & {};

export function BPTableRow(props: BPTableRowProps) {
    return <Table.Row {...props}>{props.children}</Table.Row>;
}

export type BPTableCellProps = TableCellProps & {};

export function BPTableCell(props: BPTableCellProps) {
    return <Table.Cell {...props}>{props.children}</Table.Cell>;
}

type BPTableHeaderProps = TableHeaderProps & {};

export function BPTableHeader(props: BPTableHeaderProps) {
    return <Table.Header {...props}>{props.children}</Table.Header>;
}

type BPTableBodyProps = TableBodyProps & {};

export function BPTableBody(props: BPTableBodyProps) {
    return <Table.Body {...props}>{props.children}</Table.Body>;
}

type BPTableFooterProps = TableFooterProps & {};
export function BPTableFooter(props: BPTableFooterProps) {
    return <Table.Footer {...props}>{props.children}</Table.Footer>;
}

export type BPTableHeaderCellProps = TableHeaderCellProps & {};

export function BPTableHeaderCell(props: BPTableHeaderCellProps) {
    return <Table.HeaderCell {...props}>{props.children}</Table.HeaderCell>;
}

type BPPaginationProps = PaginationProps & {};
export function BPPagination(props: BPPaginationProps) {
    return <Pagination {...props}>{props.children}</Pagination>;
}

